import { styled } from '@mui/material/styles'
import {
  Box,
  TableCell,
  TableRow,
  Button,
  Select,
  TextField,
  IconButton,
  Chip,
  Typography,
} from '@mui/material'

export const Colors = {
  primary: '#00bcd4',
  primaryHover: '#00acc1',
  error: '#f44336',
  darkBackground: '#0a0a1f',
  darkBackgroundHover: '#1a1a2e',
  borderColor: '#2a2a4a',
}

export const StyledContainer = styled(Box)({
  padding: '24px',
  color: 'white',
  backgroundColor: '#0d0d0d',
})

export const StyledTableCell = styled(TableCell)({
  color: 'white',
  borderBottom: 'unset',
})

export const TableRowHead = styled(TableRow)({
  backgroundColor: '#000000',
})

export const StyledTableRow = styled(TableRow)({
  '&:nth-of-type(odd)': {
    backgroundColor: '#090920',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#000000',
  },
})

export const StyledSelect = styled(Select)({
  width: '43px',
  backgroundColor: '#141432',
  color: 'white',
  borderRadius: '8px',
  '& .MuiSvgIcon-root': {
    color: 'white',
    width: '10px',
    height: '10px',
  },
})

export const StyledSearchField = styled(TextField)({
  maxWidth: '300px',
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
    borderRadius: '8px',
    height: '32px',
    '& fieldset': {
      borderColor: 'unset',
    },
  },
  '& input': {
    color: 'white',
  },
})

export const StyledRefreshButton = styled(Button)({
  marginLeft: 'auto',
  backgroundColor: '#00c2eb',
  borderRadius: '20px',
})

export const StyledActionButton = styled(IconButton)({
  '&.edit': {
    color: Colors.primary || '#00bcd4',
  },
  '&.delete': {
    color: Colors.error || '#f44336',
  },
})

export const StyledChip = styled(Chip)({
  backgroundColor: 'white',
  color: Colors.darkBackground || '#1a1a2e',
  borderRadius: '16px',
  fontWeight: 500,
})

export const StyledPaginationButton = styled(Button)({
  textTransform: 'none',
  minWidth: 'unset',
  padding: '8px 16px',
  width: '31px',
  height: '31px',
  borderRadius: '8px',
  '&.active': {
    backgroundColor: Colors.primary || '#00bcd4',
    '&:hover': {
      backgroundColor: Colors.primaryHover || '#00acc1',
    },
  },
  '&.inactive': {
    color: 'white',
  },
})

export const StyledPaginationText = styled(Button)({
  textTransform: 'none',
  '&.active': {
    backgroundColor: Colors.primary || '#00bcd4',
    '&:hover': {
      backgroundColor: Colors.primaryHover || '#00acc1',
    },
  },
  '&.inactive': {
    color: 'white',
  },
})

export const HeaderBox = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  backgroundColor: '#000000',
  padding: '16px',
  borderTopLeftRadius: '25px',
  borderTopRightRadius: '25px',
})

export const SearchBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  border: '1px solid #ffffff',
  borderRadius: '8px',
})

export const PaginationBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  padding: '16px 0',
  gap: '8px',
  alignItems: 'center',
  backgroundColor: '#000000',
  borderBottomLeftRadius: '25px',
  borderBottomRightRadius: '25px',
})

export const Head1 = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 11px',
  borderRadius: '14.5px',
  backgroundColor: '#0d1923',
  width: 'fit-content',
})

export const Head2 = styled(Typography)({
  fontFamily: 'Alexandria',
  fontWeight: '700',
  fontSize: '13px',
  lineHeight: '15.85px',
  letterSpacing: '1.63px',
  textAlign: 'center',
  color: '#1082e9',
  opacity: '1',
  textTransform: 'uppercase',
})

export const HeadBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '15px',
})

export const HeadBox1 = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '46px',
})

export const Head3 = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 11px',
  borderRadius: '14.5px',
  backgroundColor: '#251e0f',
  width: 'fit-content',
})

export const Head4 = styled(Typography)({
  fontFamily: 'Alexandria',
  fontWeight: '700',
  fontSize: '13px',
  lineHeight: '15.85px',
  letterSpacing: '1.63px',
  textAlign: 'center',
  color: '#feb820',
  opacity: '1',
  textTransform: 'uppercase',
})

export const MainTableBox = styled(Box)({
  border: '1px solid #EBF9F180',
  borderRadius: '20px',
})
